import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/key.svg';

export const IconKey = createIconComponent(Icon);
